* {
  padding: 0;
  margin: 0;
  border: 0;
}

body {
  background-color: #18182c;
  overflow: hidden;
  color: #FFFFFF;
  width: 100vw;
  height: 100vh;
}

object {
  width: 0;
  height: 0;
  visibility: hidden;
}

#body {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  font-family: Muli, sans-serif;
  z-index: 10;
}

#main-loader {
  position: absolute;
  z-index: 2;
  left: 2em;
  top: 2em;
  height: 2em;
  width: 2em;
}

#main-logo {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  margin-left: -50%;
  margin-top: -50%;
}

.video-wrapper {
  position: absolute;
  left: 0;
  top: 0;
  width: 1px !important;
  height: 1px !important;
}

#videos-wrapper-foreground {
  z-index: 100;
}

#videos-wrapper-background {
  z-index: 9;
}

body.tizen {
  overflow: hidden;
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 1;
}
body.tizen.portrait {
  width: 1080px;
  height: 1920px;
}
body.tizen.landscape {
  width: 1920px;
  height: 1080px;
}
body.tizen #body {
  width: 100%;
  height: 100%;
}